import React from 'react';
import { connect } from 'react-redux';

import ListPagePaginated from '@/src/shared/components/ListPage/ListPagePaginated';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { COMPLIANCE_ACCESS } from '@/src/shared/constants';
import useListSearch from '@/src/shared/hooks/useListSearch';

const ClaimsHandlingAndUnfairPracticesGuide = () => {
  const [loading, results] = useListSearch({
    pubCode: 350,
    yearsBack: 5,
  });

  return (
    <ListPagePaginated
      title="Claims Handling and Unfair Practices Compliance Guide"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      loading={loading}
    />
  );
};

export default connect(mapStateToProps)(
  withMembershipAccessWrap(
    ClaimsHandlingAndUnfairPracticesGuide,
    COMPLIANCE_ACCESS.CLAIMS_COMPLIANCE
  )
);
